import {AnyObject} from 'src';

export function isNull(obj: any) {
  return obj === null || undefined;
}

export function isObject(obj: any) {
  return obj !== null && typeof obj === 'object';
}

export function isFunction(fn: any) {
  return typeof fn === 'function';
}

export function isArray(value: any) {
  return Array.isArray(value);
}

export function isString(value: any) {
  return typeof value === 'string';
}

export function isNumber(value: any) {
  return typeof value === 'number';
}

export function isBoolean(value: any) {
  return typeof value === 'boolean';
}

export function hasChanged(value: any, oldValue: any) {
  return value !== oldValue && (value === value || oldValue === oldValue);
}

export function $(selector: string) {
  return document.querySelector(selector);
}

export function getFunArgs(func: Function) {
  // 先用正则匹配,取得符合参数模式的字符串.
  // 第一个分组是这个:  ([^)]*) 非右括号的任意字符
  // const args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];

  var args = func?.toString().match(/function\s.*?\(([^)]*)\)/)?.[1] || '';

  // 用逗号来分隔参数(arguments string).
  return args
    .split(',')
    .map(function (arg) {
      // 去除注释(inline comments)以及空格
      return arg.replace(/\/\*.*\*\//, '').trim();
    })
    .filter(function (arg) {
      // 确保没有 undefined.
      return arg;
    });
}

export function getFunName(func: Function) {
  var funName = func?.toString().match(/function\s*(\w*)/gi) || '';
  return funName;
}

/**
 * 打印 anyobj
 * @param obj
 * @returns
 */
export function getKeys<T>(obj: T) {
  if (!isObject(obj)) return [];
  return Object.keys(obj as any) as Array<keyof T>;
}

export function printObject(obj: AnyObject) {
  Object.entries(obj).forEach(([k, v]) => {
    console.log(k, v);
  });
}

/**
 * 为了依赖收集
 * @param obj
 */
export function trackObject(obj: AnyObject) {
  Object.entries(obj).forEach(([k, v]) => {
    console.log('track:' + v);
  });
}
